import 'babel-polyfill';
import Vue from 'vue';

// Import plugins
import vuetify from './plugins/vuetify';
import './plugins/vue-dot';
import './filters';

// Import application parts
import App from './App.vue';
import router from './router';
import { store } from './store';
import i18n from './i18n';

// Remove "tip" from browser console
Vue.config.productionTip = false;

// Create main Vue instance
new Vue({
	store,
	router,
	i18n,
	vuetify,
	render: (h) => h(App)
}).$mount('#app'); // Mount it on #app (in public/index.html)
